var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedCircleX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40.001,
    viewBox: "0 0 40 40.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32610",
    "data-name": "Group 32610",
    transform: "translate(-740 -430)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 20,
    cy: 20,
    rx: 20,
    ry: 20,
    transform: "translate(740 430)",
    fill: "#ffdada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "close",
    d: "M10.649,9.136l7.009-7.009A1.166,1.166,0,0,0,16.009.478L9,7.487,1.991.478A1.166,1.166,0,1,0,.342,2.127L7.351,9.136.342,16.145a1.166,1.166,0,1,0,1.649,1.649L9,10.785l7.009,7.009a1.166,1.166,0,1,0,1.649-1.649Zm0,0",
    transform: "translate(751 440.864)",
    fill: "#fd0e35"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCircleX);
export default __webpack_public_path__ + "static/media/red-circle-x.d651700a.svg";
export { ForwardRef as ReactComponent };